export default "__VITE_ASSET__FwDjVLTZ__"